//UPDATE_EMPLOYEE_PAYROLL_SETTING
export const UPDATE_EMPLOYEE_PAYROLL_SETTING_REQUEST =
  "UPDATE_EMPLOYEE_PAYROLL_SETTING_REQUEST";
export const UPDATE_EMPLOYEE_PAYROLL_SETTING_SUCCESS =
  "UPDATE_EMPLOYEE_PAYROLL_SETTING_SUCCESS";
export const UPDATE_EMPLOYEE_PAYROLL_SETTING_FAIL =
  "UPDATE_EMPLOYEE_PAYROLL_SETTING_FAIL";

//GET_EMPLOYEE_PAYROLL_SETTING
export const GET_EMPLOYEE_PAYROLL_SETTING_REQUEST =
  "GET_EMPLOYEE_PAYROLL_SETTING_REQUEST";
export const GET_EMPLOYEE_PAYROLL_SETTING_SUCCESS =
  "GET_EMPLOYEE_PAYROLL_SETTING_SUCCESS";
export const GET_EMPLOYEE_PAYROLL_SETTING_FAIL =
  "GET_EMPLOYEE_PAYROLL_SETTING_FAIL";

//GET_OFF_BOARDING_USER_DATA
export const GET_OFF_BOARDING_USER_DATA_REQUEST =
  "GET_OFF_BOARDING_USER_DATA_REQUEST";
export const GET_OFF_BOARDING_USER_DATA_SUCCESS =
  "GET_OFF_BOARDING_USER_DATA_SUCCESS";
export const GET_OFF_BOARDING_USER_DATA_FAIL =
  "GET_OFF_BOARDING_USER_DATA_FAIL";

//GET_ANOTHER_COMPANY_SALARY_BREAK_DOWN
export const GET_ANOTHER_COMPANY_SALARY_BREAK_DOWN_REQUEST =
  "GET_ANOTHER_COMPANY_SALARY_BREAK_DOWN_REQUEST";
export const GET_ANOTHER_COMPANY_SALARY_BREAK_DOWN_SUCCESS =
  "GET_ANOTHER_COMPANY_SALARY_BREAK_DOWN_SUCCESS";
export const GET_ANOTHER_COMPANY_SALARY_BREAK_DOWN_FAIL =
  "GET_ANOTHER_COMPANY_SALARY_BREAK_DOWN_FAIL";

//GET_OFF_BOARDING_ALL_DATA
export const GET_OFF_BOARDING_ALL_DATA_REQUEST =
  "GET_OFF_BOARDING_ALL_DATA_REQUEST";
export const GET_OFF_BOARDING_ALL_DATA_SUCCESS =
  "GET_OFF_BOARDING_ALL_DATA_SUCCESS";
export const GET_OFF_BOARDING_ALL_DATA_FAIL = "GET_OFF_BOARDING_ALL_DATA_FAIL";

//ADD_OFF_BOARDING_DATA
export const ADD_OFF_BOARDING_DATA_REQUEST = "ADD_OFF_BOARDING_DATA_REQUEST";
export const ADD_OFF_BOARDING_DATA_SUCCESS = "ADD_OFF_BOARDING_DATA_SUCCESS";
export const ADD_OFF_BOARDING_DATA_FAIL = "ADD_OFF_BOARDING_DATA_FAIL";

//ADD_APPRAISAL_DATA
export const ADD_APPRAISAL_DATA_REQUEST = "ADD_APPRAISAL_DATA_REQUEST";
export const ADD_APPRAISAL_DATA_SUCCESS = "ADD_APPRAISAL_DATA_SUCCESS";
export const ADD_APPRAISAL_DATA_FAIL = "ADD_APPRAISAL_DATA_FAIL";

//ADD_TRANSFER_DATA
export const ADD_TRANSFER_DATA_REQUEST = "ADD_TRANSFER_DATA_REQUEST";
export const ADD_TRANSFER_DATA_SUCCESS = "ADD_TRANSFER_DATA_SUCCESS";
export const ADD_TRANSFER_DATA_FAIL = "ADD_TRANSFER_DATA_FAIL";

//ADD_MOVE_DATA
export const ADD_MOVE_DATA_REQUEST = "ADD_MOVE_DATA_REQUEST";
export const ADD_MOVE_DATA_SUCCESS = "ADD_MOVE_DATA_SUCCESS";
export const ADD_MOVE_DATA_FAIL = "ADD_MOVE_DATA_FAIL";

//ADD_OFFBOARDING_DATA
export const ADD_OFFBOARDING_DATA_REQUEST = "ADD_OFFBOARDING_DATA_REQUEST";
export const ADD_OFFBOARDING_DATA_SUCCESS = "ADD_OFFBOARDING_DATA_SUCCESS";
export const ADD_OFFBOARDING_DATA_FAIL = "ADD_OFFBOARDING_DATA_FAIL";

//UPDATE_PAYROLL_CATEGORY_SETTING
export const UPDATE_PAYROLL_CATEGORY_SETTING_REQUEST =
  "UPDATE_PAYROLL_CATEGORY_SETTING_REQUEST";
export const UPDATE_PAYROLL_CATEGORY_SETTING_SUCCESS =
  "UPDATE_PAYROLL_CATEGORY_SETTING_SUCCESS";
export const UPDATE_PAYROLL_CATEGORY_SETTING_FAIL =
  "UPDATE_PAYROLL_CATEGORY_SETTING_FAIL";

//GET_EMPLOYEE_PAYROLL_TIMERECORD
export const GET_EMPLOYEE_PAYROLL_TIMERECORD_REQUEST =
  "GET_EMPLOYEE_PAYROLL_TIMERECORD_REQUEST";
export const GET_EMPLOYEE_PAYROLL_TIMERECORD_SUCCESS =
  "GET_EMPLOYEE_PAYROLL_TIMERECORD_SUCCESS";
export const GET_EMPLOYEE_PAYROLL_TIMERECORD_FAIL =
  "GET_EMPLOYEE_PAYROLL_TIMERECORD_FAIL";

//ADD_MAIN_PAYROLL_OF_COMPANY
export const ADD_MAIN_PAYROLL_OF_COMPANY_REQUEST =
  "ADD_MAIN_PAYROLL_OF_COMPANY_REQUEST";
export const ADD_MAIN_PAYROLL_OF_COMPANY_SUCCESS =
  "ADD_MAIN_PAYROLL_OF_COMPANY_SUCCESS";
export const ADD_MAIN_PAYROLL_OF_COMPANY_FAIL =
  "ADD_MAIN_PAYROLL_OF_COMPANY_FAIL";

//ADD_GENERATE_PAYROLL_OF_COMPANY
export const ADD_GENERATE_PAYROLL_OF_COMPANY_REQUEST =
  "ADD_GENERATE_PAYROLL_OF_COMPANY_REQUEST";
export const ADD_GENERATE_PAYROLL_OF_COMPANY_SUCCESS =
  "ADD_GENERATE_PAYROLL_OF_COMPANY_SUCCESS";
export const ADD_GENERATE_PAYROLL_OF_COMPANY_FAIL =
  "ADD_GENERATE_PAYROLL_OF_COMPANY_FAIL";

//ADD_SALARY_BREAK_DOWN
export const ADD_SALARY_BREAK_DOWN_REQUEST = "ADD_SALARY_BREAK_DOWN_REQUEST";
export const ADD_SALARY_BREAK_DOWN_SUCCESS = "ADD_SALARY_BREAK_DOWN_SUCCESS";
export const ADD_SALARY_BREAK_DOWN_FAIL = "ADD_SALARY_BREAK_DOWN_FAIL";

//ADD_SALARY_BREAK_DOWN_BY_USER
export const ADD_SALARY_BREAK_DOWN_BY_USER_REQUEST =
  "ADD_SALARY_BREAK_DOWN_BY_USER_REQUEST";
export const ADD_SALARY_BREAK_DOWN_BY_USER_SUCCESS =
  "ADD_SALARY_BREAK_DOWN_BY_USER_SUCCESS";
export const ADD_SALARY_BREAK_DOWN_BY_USER_FAIL =
  "ADD_SALARY_BREAK_DOWN_BY_USER_FAIL";

//UPLOAD_PAYSLIPS
export const UPLOAD_PAYSLIPS_REQUEST = "UPLOAD_PAYSLIPS_REQUEST";
export const UPLOAD_PAYSLIPS_SUCCESS = "UPLOAD_PAYSLIPS_SUCCESS";
export const UPLOAD_PAYSLIPS_FAIL = "UPLOAD_PAYSLIPS_FAIL";

//EDIT_UPLOAD_PAYSLIPS
export const EDIT_UPLOAD_PAYSLIPS_REQUEST = "EDIT_UPLOAD_PAYSLIPS_REQUEST";
export const EDIT_UPLOAD_PAYSLIPS_SUCCESS = "EDIT_UPLOAD_PAYSLIPS_SUCCESS";
export const EDIT_UPLOAD_PAYSLIPS_FAIL = "EDIT_UPLOAD_PAYSLIPS_FAIL";

//CREATE_GENERATE_IN_UPOLAD_PAYSLIPS
export const CREATE_GENERATE_IN_UPOLAD_PAYSLIPS_REQUEST =
  "CREATE_GENERATE_IN_UPOLAD_PAYSLIPS_REQUEST";
export const CREATE_GENERATE_IN_UPOLAD_PAYSLIPS_SUCCESS =
  "CREATE_GENERATE_IN_UPOLAD_PAYSLIPS_SUCCESS";
export const CREATE_GENERATE_IN_UPOLAD_PAYSLIPS_FAIL =
  "CREATE_GENERATE_IN_UPOLAD_PAYSLIPS_FAIL";

//DELETE_PAYROLL
export const DELETE_PAYROLL_REQUEST = "DELETE_PAYROLL_REQUEST";
export const DELETE_PAYROLL_SUCCESS = "DELETE_PAYROLL_SUCCESS";
export const DELETE_PAYROLL_FAIL = "DELETE_PAYROLL_FAIL";

export const SET_FIRST_CATEGORY = "SET_FIRST_CATEGORY";
export const SET_DATA_CATEGORY = "SET_DATA_CATEGORY";
export const SET_PAYROLL_ADDITION_DEDUCTION = "SET_PAYROLL_ADDITION_DEDUCTION";
export const SET_PAYROLL_PROCESS = "SET_PAYROLL_PROCESS";
export const SET_IMPORT_PROCESS_PAYROLL = "SET_IMPORT_PROCESS_PAYROLL";
export const SET_IMPORT_ADDITIONAL_PAYROLL = "SET_IMPORT_ADDITIONAL_PAYROLL";
export const SET_IMPORT_REVIEW_PAYROLL = "SET_IMPORT_REVIEW_PAYROLL";
